/* eslint-disable import/prefer-default-export */
export const CONDITIONS: string[] = [
  'SS014',
  'SS015',
  'SS016',
  'SS017',
  'SS018',
  'SS019',
  'SS020',
  'SS021',
  'SS023',
  'SS024',
  'SS025',
  'SS026',
  'SS027',
  'SS028',
  'SS029',
  'SS030',
  'SS031',
  'SS032',
  'SS033',
  'SS034',
  'SS035',
  'SS036',
  'SS037',
];
